// src/components/FAQSection.jsx
import React, { useState } from "react";
import "./FAQSection.css";

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      q: "Who can apply for the internship?",
      a: "The internship is open for all students including freshers, BTech/MTech students from all branches who are interested in AI, GenAI, and Agriculture applications."
    },
    {
      q: "Is the internship free?",
      a: "Yes, the internship training is free. A small registration fee may be applicable to confirm your seat."
    },
    {
      q: "What is the duration of each batch?",
      a: "Each batch runs for 3 months. Example: Batch 1 (Jul–Sep 2025), Batch 2 (Oct–Dec 2025)."
    },
    {
      q: "Will I get a certificate?",
      a: "Yes! All participants who successfully complete the program will receive a certificate and mentorship support."
    },
    {
      q: "Is it online or offline?",
      a: "The internship is completely online, so you can join from anywhere in India."
    }
  ];

  const toggleFAQ = (i) => {
    setActiveIndex(activeIndex === i ? null : i);
  };

  return (
    <section className="faq-section" id="faq">
      <h2 className="faq-title">❓ Frequently Asked Questions</h2>
      <div className="faq-container">
        {faqs.map((faq, i) => (
          <div
            key={i}
            className={`faq-item ${activeIndex === i ? "active" : ""}`}
            onClick={() => toggleFAQ(i)}
          >
            <div className="faq-question">
              {faq.q}
              <span className="faq-toggle">{activeIndex === i ? "−" : "+"}</span>
            </div>
            {activeIndex === i && <div className="faq-answer">{faq.a}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
